<template>
  <div
    v-tooltip="tooltipOptions"
    class="dropdown"
    :class="dropdownClasses"
    :title="title"
  >
    <a
      class="dropdown-toggle"
      :class="triggerClasses"
      data-toggle="dropdown"
    >
      <slot name="trigger" />
    </a>
    <ul
      class="dropdown-menu toggling-dropdown"
      :class="listClass"
    >
      <li class="dropdown-header">
        <slot name="header" />
      </li>
      <slot />
    </ul>
  </div>
</template>

<script>
export default {
  name: 'AppToggleDropdown',
  props: {
    title: String,
    triggerClasses: {
      type: String,
      default: 'btn btn-icon btn-default',
    },
    direction: {
      type: String,
      default: 'right',
    },
    dropdownClasses: {
      type: String,
      default: '',
    },
    extraClasses: {
      type: String,
      default: '',
    },
    tooltipOptions: {
      type: Object,
      default: () => ({
        placement: 'left',
        delay: { hide: 2000 },
      }),
    },
  },
  data() {
    return {
      toggledColumns: {},
    };
  },
  computed: {
    listClass() {
      return `${this.directionClass} ${this.extraClasses}`;
    },
    directionClass() {
      return `dropdown-menu-${this.direction}`;
    },
  },
  created() {
    this.$on('table_col_toggled', ({ col, on }) => {
      col = col.replace(/^show_/, '');
      if (this.toggledColumns[col] === undefined) {
        this.toggledColumns[col] = on;
      } else {
        delete this.toggledColumns[col]; // need only changes, ignore state restore
      }
    });
  },
  mounted() {
    $(this.$el).on('hide.bs.dropdown', () => this.sendAnalyticsEvent());
  },
  methods: {
    sendAnalyticsEvent() {
      const colsNumber = Object.keys(this.toggledColumns).length;

      if (colsNumber === 0) {
        return;
      }

      window.analytics?.track('Table cols updated', {
        cols_number: colsNumber,
        cols_added: Object.keys(this.toggledColumns).filter((col) => this.toggledColumns[col]),
        cols_removed: Object.keys(this.toggledColumns).filter((col) => !this.toggledColumns[col]),
        ...this.$store.getters.analyticsTableColsProps,
      });
      this.toggledColumns = {};
    },
  },
};
</script>
